PJQ.Slider = class {
	constructor($el, options = {}) {
		this.$el = $el;
		this.options = _.defaults(options, {
			fitHorizontal: true,
			onChange: _.noop
		});
		if (_.size(this.$el) > 0) {
			this.slider = this.$el.bootstrapSlider(this.options).on('change', _.bind(this.onChange, this));
			if (this.options.fitHorizontal) {
				this.$el.prev('.slider.slider-horizontal').addClass('wd-100');
			}
			this.refresh();
		}
	}

	refresh() {
		this.slider.bootstrapSlider('refresh');
	}

	getValue() {
		return this.slider.bootstrapSlider('getValue');
	}

	setValue(value) {
		this.slider.bootstrapSlider('setValue', value);
	}

	onChange(obj) {
		this.options.onChange(obj.value);
	}
};